import PropTypes from 'prop-types';
import React from 'react';

// material-ui
// --- THIS IS THE FIX ---
// We remove `makeStyles` and update `useTheme` to import from the modern styling engine.
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { drawerWidth } from 'utils/constant';

// The old useStyles hook is no longer needed. The styles are moved to `sx` props.

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    // The classes variable is no longer needed.
    // const classes = useStyles();
    const theme = useTheme(); // This hook now correctly receives the global theme.
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    const drawer = (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                {/* Styles from the old `boxContainer` class are now here */}
                <Box sx={{ display: 'flex', padding: '16px', marginLeft: 'auto', marginRight: 'auto' }}>
                    <LogoSection />
                </Box>
            </Box>
            <BrowserView>
                {/* We wrap PerfectScrollbar in a Box to apply the styles from the old `ScrollHeight` class */}
                <Box sx={{
                    height: 'calc(100vh - 88px)',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    [theme.breakpoints.down('sm')]: {
                        height: 'calc(100vh - 56px)'
                    }
                }}>
                    <PerfectScrollbar component="div">
                        <MenuList />
                    </PerfectScrollbar>
                </Box>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                </Box>
            </MobileView>
        </>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        // The outer nav's styles from the old `drawer` class are now here
        <Box component="nav" sx={{ [theme.breakpoints.up('md')]: { width: drawerWidth, flexShrink: 0 } }} aria-label="App sidebar">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                // The old `classes` prop is replaced with `PaperProps` and the `sx` prop
                PaperProps={{
                    sx: {
                        width: drawerWidth,
                        // NOTE: The original background color '#ff00000' was invalid CSS. It has been corrected to '#ff0000' (red).
                        // This may have been a debug color. You might want to change it to `theme.palette.background.default`.
                        background: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;